// extracted by mini-css-extract-plugin
module.exports = {"block":"RMdkm","footer":"ZJrv4"};